import { Box, Typography } from "@material-ui/core"
import { useState } from "react"
import styled from "styled-components"
import MinusIcon from "../../components/Icons/MinusIcon"
import PlusIcon from "../../components/Icons/PlusIcon"

const StyledQuestionBox = styled(Box)`
  border-top: 1px solid #264f36;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 66px;
  cursor: pointer;
  svg {
    cursor: pointer;
    margin-left: 10px;
  }

  :hover {
    text-decoration: underline;
  }
`
const StyledQuestion = styled(Typography).attrs({ variant: "body2" })<{
  $expand: boolean
}>`
  color: #264f36;
  font-weight: ${(p) => (p.$expand ? "bold" : "100")};
`
const StyledAnswer = styled(Typography).attrs({ variant: "body1" })`
  text-align: right;
  padding-bottom: 20px;
  margin-right: 10px;
`

type FaqWrapperProps = {
  question: string
  answer: string
  key: number
}

const FaqWrapper = ({ question, answer, key }: FaqWrapperProps) => {
  const [expand, setExpand] = useState(false)
  return (
    <>
      <StyledQuestionBox
        key={key}
        onClick={() => setExpand(!expand)}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter") setExpand(!expand)
        }}
      >
        <StyledQuestion $expand={expand}>{question}</StyledQuestion>
        {expand ? <MinusIcon /> : <PlusIcon />}
      </StyledQuestionBox>
      {expand && <StyledAnswer>{answer}</StyledAnswer>}
    </>
  )
}

export default FaqWrapper
